export default {
	name 		: "workspace_ag",
	components 	: {

	}, 
	data 		: (vm) => ({
		search : {
			email : "",
		},
		list_search : [
			{
				col 		: 11,
				key 		: "email",
				type 		: "text",
				icon 		: "mdi-email",
				text 		: vm.$ml.get('email'),
				placeholder : vm.$ml.get('email'), 
				disable  	: true,

			},
			/*{
				col 		: 1,
				key 		: "search",
				action 		: "search",
				type 		: "btn",
				icon 		: "mdi-magnify",
				color 		: "primary",
				text 		: vm.$ml.get('email'),
				placeholder : vm.$ml.get('email'), 

			}*/
		],
		show 	: {},
		list 	: [],
		options : { itemsPerPage : 30 },
		headers : [
			{ text : vm.$ml.get("name"), value : "name" },			
			{ text : vm.$ml.get("workspace"), value : "workspace" },
			{ text : vm.$ml.get("domain"), value : "domain" },
			{ text : vm.$ml.get("actions"), value : "actions" },
		],
		loading 		: false,
		total 			: 0, 
		height_table 	: "400px",
		list_actions 	: [
			{
				text 	: "redirect",
				action 	: "redirect",
				color 	: "primary",
				icon 	: "mdi-arrow-right-top",
			}
		],

	}), // data

	created(){
		this.render_email_user();

	}, // created
	
	watch : {
		options : {
			handler(){
				if (this.search && this.search.email) {
					this.get_search();
				}else{
					this.get_list();

				}
			}
		}, // options 

	}, // watch

	computed : {
		render_list : function(){
			return this.list;
		}, // render list

	}, // computed

	methods : {
		actions(act, item, opt){
			if (act == 'search') {
				this.get_search();
			}else
			if (act == 'redirect') {
				if (item.domain) {
					window.open(item.domain,'_blank');
				}
			}
		}, // actions

		render_email_user(){
			// console.log("USER ************" , this.$store.state.auth)
			if (this.$store.state.auth && this.$store.state.auth.user && this.$store.state.auth.user.user) {
				this.search.email = this.$store.state.auth.user.user.email;

			}
		}, // render_email_user

		get_list(){

		}, // get list

		get_search(){
			this.loading = true;
			const api 	 = 'https://getworkspace.alicesecurity.co/clients/getWorkspaces/?secret_key=ASDFGHJKL%C3%91';
			this.$axios.post(api, this.search).then(res =>{
				this.loading = false;
				if (res && res.data && res.data.data && res.data.data.length > 0){
					console.log("RES ", res)
					this.list  = res.data.data;
					this.total = res.data.data.length;
				}
			}).catch(err => {
				this.loading = false;
				console.log("Error get workspace : ", err)
			});		
		}, // search
	}, // methods
}; // export default